var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "profile-input-wrapper" },
    [
      _c("profile-form", { ref: "form", attrs: { endpoint: "interests" } }, [
        _c("form", { staticClass: "form" }, [
          _c("fieldset", [
            _c("legend", { staticClass: "sr-only" }, [
              _vm._v("\n          " + _vm._s(_vm.inputTitle) + "\n        "),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "profile-input-label" }, [
              _vm._v(_vm._s(_vm.listLabel)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-grid-1-col gutter-lg" }, [
              _c(
                "ul",
                {},
                _vm._l(_vm.interestsList, function (interest, index) {
                  return _c(
                    "li",
                    { key: index, staticClass: "profile-input-checkbox" },
                    [
                      _c("label", [
                        _c("input", {
                          attrs: {
                            id: interest.value,
                            type: "checkbox",
                            name: "interest-" + index,
                            "data-field-type": "CheckBoxSet",
                          },
                          domProps: {
                            value: interest.value,
                            checked: _vm.localProfile.interests
                              .map(function (item) {
                                return item.value
                              })
                              .includes(interest.value),
                          },
                          on: { input: _vm.onInput },
                        }),
                        _vm._v(
                          "\n                " +
                            _vm._s(interest.label) +
                            "\n              "
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "isActivitiesInterests" },
            domProps: { value: true },
          }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }